var exports = {
  "kL": "xe533113f--6c1ecc--container",
  "kA": "xe533113f--6c1ecc--icon-container",
  "UE": "xe533113f--6c1ecc--arrow",
  "Kk": "xe533113f--6c1ecc--icon",
};

module.exports = exports;
